/**
 * Read-only mode of a month screen (decisions-log V206): inside a closed month every editing
 * primitive (`CellInput`, `InlineSelect`, `IconAction`, the form inputs) stops writing; navigation,
 * previews and downloads keep working.
 */
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

/** Tooltip of a write control switched off in a closed month. */
export const READ_ONLY_TITLE = 'Месяц закрыт';

const ReadOnlyContext = createContext(false);

export interface ReadOnlyProviderProps {
  readonly isReadOnly: boolean;
  readonly children: ReactNode;
}

export function ReadOnlyProvider({ isReadOnly, children }: ReadOnlyProviderProps) {
  return <ReadOnlyContext.Provider value={isReadOnly}>{children}</ReadOnlyContext.Provider>;
}

/** True inside a closed month: write controls render disabled or read-only. */
export const useIsReadOnly = (): boolean => useContext(ReadOnlyContext);
